import { Injectable, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs'
import { mergeMapTo } from 'rxjs/operators';
import { ApiService } from './api.service';
import { AuthenticationService } from './authentication.service';
import { map } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { TranslateService } from '../_services/translate.service';

@Injectable()
export class MessagingService {
  res: any;
  currentCount = new BehaviorSubject(null)
  currentMessage = new BehaviorSubject(null)
  notification: any;
  data: any;
  url: any;
  viewBtnText: string;
  cancelBtnText: string;
  constructor(private afAuth: AngularFireAuth,
    private ngZone: NgZone,
    private router: Router,
    private afMessaging: AngularFireMessaging,
    private authenticationService: AuthenticationService,
    private api: ApiService,
    private location: Location,
    private snackBar: MatSnackBar,
    private translate: TranslateService) {
    this.setText()
  }
  updateToken(token) {
    const currentValue = this.authenticationService.currentUserValue;
    if (currentValue) {
      var data = { token: token };
      //  this.api.updateToken(data).pipe(first())
      //         .subscribe(res => {
      //                 if(res.status == 200){

      //                 }
      //             },
      //             error => {

      //       }); 

    }

  }

  requestPermission() {
    console.log("46")
    this.afMessaging.requestPermission
      .subscribe(
        () => { console.log('Permission granted!'); },
        (error) => {
          console.log(error);
          this.requestToGetPushNotification()

        },
      );
  }

  getPermission(): Promise < string > {
    return new Promise((resolve, reject) => {
      this.afMessaging.requestToken.subscribe(
        (token) => {
          console.log("token", token);
          localStorage.setItem('pushtoken', token);
          resolve(token);
        },
        (error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }

  listen() {
    console.log("SAdsadasdasdsdasdsadasdsds")
    this.afMessaging.messages
      .subscribe((message) => {
        this.ngZone.run(() => {
          this.url = window.location.pathname.split('/')[1];
          console.log("Messaging service url is : ", this.url)
        });
        console.log(message)
        this.res = message;
        this.notification = this.res.notification
        this.data = this.res.data
        console.log("83", this.notification)
        console.log("83", this.data)
        this.showPushNotificationMessage(this.notification)
        this.currentCount.next(this.res.data.count);
        if (this.res.data.count) {
          this.snackBar.open(this.res.notification.title, "view", {
            duration: 50000,
          }).onAction().subscribe(() => this.router.navigate(['/notifications']));
        }
      }, error => {
        console.log(error)
      });
  }

  updateUIForPushPermissionRequired() {
    alert("deivame accept above")
  }

  showPushNotificationMessage(val) {
    this.setText()
    Swal.fire({
      title: val.title,
      html: val.body,
      iconHtml: '<img src="assets/images/bell.png">',
      showCancelButton: true,
      showCloseButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: this.viewBtnText,
      cancelButtonText: this.cancelBtnText
    }).then((result) => {
      if (result.isConfirmed) {
        this.goToView();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  }


  requestToGetPushNotification() {
    const currentLang = this.translate.currentLanguageValue;

    if (currentLang && currentLang.language == 'en') {
      var text = "You must allow notifications in order to receive alert messages.<br><br> 1. Click the <b>'Padlock'</b> or <b>'Secure'</b> icon to the left of the URL. <br> 2. Allow <b>Notifications</b> and refresh the page."
      var head = 'Notification Alert';
    } else {
      var text = "Vous devez autoriser les notifications pour recevoir des messages d'alerte.<br><br> 1. Cliquez sur l'icône <b>'Cadenas'</b> ou <b>'Sécurisé'</b> à gauche de l'URL. <br> 2. Autorisez les <b>Notifications</b> et actualisez la page.";
      var head = 'Alerte de notification';
    }
    Swal.fire({
      title: head,
      html: text,
      iconHtml: '<img src="assets/images/bell.png">',
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'OK'
    }).then((result) => {
      if (result.value) {
        setTimeout(() => {
          // this.requestPermission();
        }, 500);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    })
  }
  goToView() {
    if (this.data.landing_page) {
      var page = this.data.landing_page
    }
    if (this.data.uuid) {
      var id = this.data.uuid
    }
    console.log(id)
    switch (page) {
      case 'dashboard':
        {
          if (this.url == 'dashboard') {
            window.location.reload();
          }
          this.router.navigate(['/dashboard']);
          break;
        }
      case 'employees':
        {
          if (this.url == 'employees') {
            window.location.reload();
          } else {
            this.router.navigate(['/employees']);
          }

          break;
        }
      case 'employee-list':
        {
          this.router.navigate(['/employee-list', id], { fragment: '1' });
          break;
        }
      case 'cnss-reports':
        {
          this.router.navigate(['/cnss-reports', id]);
          break;
        }
      case 'cnamgs-report':
        {
          this.router.navigate(['/cnamgs-report', id]);
          break;
        }
      case 'cnss-report-view':
        {
          this.router.navigate(['/cnss-report-view', id]);
          break;
        }
      case 'cnamgs-reportview':
        {
          this.router.navigate(['/cnamgs-reportview', id]);
          break;
        }
    }
  }
  setText() {
    const currentLang = this.translate.currentLanguageValue;
    if (currentLang && currentLang.language == 'en') {
      this.viewBtnText = "View Page"
      this.cancelBtnText = 'Close';
      console.log(this.viewBtnText)
      console.log(this.cancelBtnText)
    } else {
      this.viewBtnText = "Page de visualisation"
      this.cancelBtnText = 'Fermer';
      console.log(this.viewBtnText)
      console.log(this.cancelBtnText)
    }
  }
}
